<div class="full-background-gray">
  <div class="container feature-prod">
    <div class="row-fluid">
      <h1 class="yellowgradient">{{ featureProd.products[0].heading }}</h1>
      <div class="equal-height subcategories">
        <article
          class="featured-item"
          *ngFor="let item of featureProd.products[0].displayItems"
        >
          <h2>
            <a [attr.href]="item.navigation.Url+'?v=1'" target="_blank">{{
              item.keyText
            }}</a>
          </h2>
          <p>
            {{ item.description }}
          </p>
          <a
            [attr.href]="item.navigation.Url"
            target="_blank"
            class="icon-follow"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.41 18">
              <defs>
                <style>
                  .cls-1prodarrow,
                  .cls-2prodarrow {
                    fill: none;
                    stroke: #009ce5;
                    stroke-miterlimit: 10;
                    stroke-width: 2px;
                  }
                  .cls-2 {
                    stroke-linecap: round;
                  }
                </style>
              </defs>
              <g data-name="Layer 2">
                <g data-name="Layer 1">
                  <line class="cls-1prodarrow" y1="9" x2="23" y2="9"></line>
                  <polyline
                    class="cls-2prodarrow"
                    points="15 1 23 9 15 17"
                  ></polyline>
                </g>
              </g>
            </svg>
          </a>
        </article>

        <article class="featured-item">
          <h2 class="brochures">{{ featureProd.brochures[0].heading }}</h2>
          <ul class="dashed">
            <li *ngFor="let item of featureProd.brochures[0].displayItems">
              <a [attr.href]="item.navigation.Url+'?v=1'" target="_blank">{{
                item.keyText
              }}</a>
            </li>
          </ul>
        </article>
      </div>
    </div>
  </div>
</div>
